import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { AddBookDTO } from "./AddBook";
type BookResponse  = AddBookDTO & {
    id:string;
    createdAt:string;
    updatedAt:string;
} & ApiError;

export const EditBook = (data: AddBookDTO,id:string): Promise<BookResponse> => {
    return axios.patch(`/book/${id}`, data)
        .then(response => response.data as BookResponse);
};